import { gql } from '@apollo/client';

export const LOCATION_DETAILS = gql`
  query location($id: ID!) {
    location(id: $id) {
      code
      name
      details {
        pace
        petTypes
        selectedAppointmentTypes
        availableAppointmentTypes
        equipmentTypes
      }
      featuredReviews {
        comment
      }
    }
  }
`;

export const HOSPITAL_PROFILE_DETAILS = gql`
  query location($code: String!) {
    location(code: $code) {
      code
      name
      street1
      state
      zipCode
      photos {
        photo
        description
        thumbnail
      }
      details {
        pace
        petTypes
        selectedAppointmentTypes
        availableAppointmentTypes
        equipmentTypes
        hospitalManager
        dvmsPerShift
        paraStaffPerDvm
        hospitalWebsiteUrl
      }
      dispatchDistrict {
        hospitalLeaders {
          name
        }
      }
      featuredReviews {
        comment
      }
    }
  }
`;
